import * as React from "react";
const SvgOutdoorArea = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M22.5 9a7.001 7.001 0 0 1-6 6.93v4.57h5.25a.75.75 0 0 1 0 1.5H3.25a.75.75 0 0 1 0-1.5h.958a2.5 2.5 0 0 1 1.647-3.416 2.999 2.999 0 0 1 5.502.499 2.251 2.251 0 0 1 1.515 2.917H15v-4.518A7 7 0 1 1 22.5 9ZM10 9a5.5 5.5 0 0 0 5 5.478V13.06l-2.028-2.03a.75.75 0 0 1 1.062-1.06l.966.968V6.75a.75.75 0 0 1 1.5 0v1.189l.72-.72a.75.75 0 0 1 1.06 1.06l-1.78 1.782v4.348a5.502 5.502 0 0 0-1-10.909A5.5 5.5 0 0 0 10 9Zm.75 11.5h.048a.75.75 0 0 0-.046-1.5h-.012a.75.75 0 0 1-.75-.668 1.5 1.5 0 0 0-2.906-.33.75.75 0 0 1-.655.5 1 1 0 0 0 .003 1.998h4.318Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgOutdoorArea;
